import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SvgService {
    private readonly svgImages: { [key: string]: string } = {
        'google-logo': '/assets/svg/google-logo.svg',
        'iitb-eo-logo': '/assets/svg/iitb-eo-logo.svg',
        'expand-more': '/assets/svg/expand-more.svg',
        'expand-less': '/assets/svg/expand-less.svg',
        'up-arrow': '/assets/svg/up-arrow.svg',
        'empty-state': '/assets/svg/empty-state.svg',
        'hamburger-menu': '/assets/svg/hamburg-menu.svg',
        'close-button': '/assets/svg/close.svg',
        'server-down': '/assets/svg/server-down.svg',
        'connection-lost': '/assets/svg/connection-lost.svg',
        'session-expired': '/assets/svg/session-expired.svg',
    };

    private readonly svgVectors: { [key: string]: string } = {
        'enrollment-stepper-bg-vector': '/assets/vectors/enrollment-stepper-bg-vector.svg',
        'my-learnings-vector': '/assets/vectors/my-learnings-vector.svg',
        'payment-success-vector': '/assets/vectors/payment-successful-vector.svg',
        'payment-failed-vector': '/assets/vectors/payment-failed-vector.svg',
        'enrolled-stepper-bg-vector': '/assets/vectors/enrolled-stepper-bg-vector.svg',
    };

    getImage(name: string): string {
        return this.svgImages[name] || '';
    }

    getVector(name: string): string {
        return this.svgVectors[name] || '';
    }
}
